import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var CornerRightDown = createReactComponent("CornerRightDown", ["svg", defaultAttributes, [["polyline", {
  points: "10 15 15 20 20 15",
  key: "cidjhy"
}], ["path", {
  d: "M4 4h7a4 4 0 014 4v12",
  key: "fw55me"
}]]]);
export default CornerRightDown;